import React from 'react';
import { Link } from 'react-router-dom';
import { useContent, useLanguage, useUI, useLocalPath } from '../context/LanguageContext';

const Footer = () => {
  const content = useContent();
  const { prefix } = useLanguage();
  const ui = useUI();

  return (
    <footer className="border-t border-[#21262d] py-8">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <Link to={prefix ? `${prefix}/` : '/'} className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-full border border-[#3b82f6]/50 flex items-center justify-center bg-[#3b82f6]/10">
              <span className="font-mono text-[10px] font-bold text-[#3b82f6]">G2</span>
            </div>
            <span className="font-mono text-[11px] font-semibold tracking-[0.2em] text-[#e6edf3] uppercase">
              Go2 Digital
            </span>
          </Link>

          <div className="flex items-center gap-6">
            {content.navLinks.map((link) => (
              <Link
                key={link.label}
                to={`${prefix}${link.href}`}
                className="font-mono text-[10px] tracking-[0.15em] text-[#7d8590] hover:text-[#e6edf3] transition-colors uppercase"
              >
                {link.label}
              </Link>
            ))}
          </div>

          <p className="font-mono text-[10px] tracking-[0.1em] text-[#7d8590]">
            {ui.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
